import {useAbility} from "@casl/react";

import {useGetStoresShortQuery} from "~/api/generated";
import {strongSelectMaker, useAppSelector} from "~/modules/redux";
import {AbilityContext} from "~/modules/roles";

export const useAllStores = () => {
  const maker = useAppSelector(strongSelectMaker);
  const abilities = useAbility(AbilityContext);
  const canReadCommerce = abilities.can("read", "commerce");

  const {data, isLoading, isFetching} = useGetStoresShortQuery({makerId: maker.id}, {skip: !canReadCommerce});

  return {
    stores: data?.stores ?? [],
    canReadCommerce,
    isLoading,
    isFetching,
  };
};
